var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 737 544",
    width: 737,
    height: 544,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 737,
    height: 544,
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L737,0 L737,544 L0,544z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_108)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_110)",
    transform: "matrix(11.779999732971191,0,0,11.779999732971191,-3972.4296875,-2932.159912109375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,346.26397705078125,261.09698486328125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,26.023000717163086,16.479999542236328)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(70,165,253)",
    fillOpacity: 1,
    d: " M-6.413000106811523,-16.229999542236328 C-6.413000106811523,-16.229999542236328 -25.773000717163086,16.229999542236328 -25.773000717163086,16.229999542236328 C-25.773000717163086,16.229999542236328 6.410999774932861,16.229999542236328 6.410999774932861,16.229999542236328 C6.410999774932861,16.229999542236328 25.773000717163086,-16.229999542236328 25.773000717163086,-16.229999542236328 C25.773000717163086,-16.229999542236328 -6.413000106811523,-16.229999542236328 -6.413000106811523,-16.229999542236328z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9980207681655884,0.06288490444421768,-0.06288490444421768,0.9980207681655884,339.1758728027344,260.37957763671875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,11.850000381469727,14.529999732971191)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(45,98,212)",
    fillOpacity: 1,
    d: " M-11.600000381469727,-14.267000198364258 C-11.600000381469727,-14.267000198364258 2.2070000171661377,8.857000350952148 2.2070000171661377,8.857000350952148 C2.2070000171661377,8.857000350952148 4.2129998207092285,12.218999862670898 4.2129998207092285,12.218999862670898 C4.2129998207092285,12.218999862670898 10.538000106811523,14.279999732971191 10.538000106811523,14.279999732971191 C10.538000106811523,14.279999732971191 11.600000381469727,7.519999980926514 11.600000381469727,7.519999980926514 C11.600000381469727,7.519999980926514 9.699999809265137,4.339000225067139 9.699999809265137,4.339000225067139 C9.699999809265137,4.339000225067139 -1.4149999618530273,-14.279999732971191 -1.4149999618530273,-14.279999732971191 C-1.4149999618530273,-14.279999732971191 -11.600000381469727,-14.267000198364258 -11.600000381469727,-14.267000198364258z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9352741241455078,0.3539241552352905,-0.3539241552352905,0.9352741241455078,373.2241516113281,245.1697540283203)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,15.020999908447266,15.147000312805176)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(45,98,212)",
    fillOpacity: 1,
    d: " M2.052999973297119,-3.0510001182556152 C2.052999973297119,-3.0510001182556152 6.76200008392334,8.875 6.76200008392334,8.875 C6.76200008392334,8.875 -5.059999942779541,8.875 -5.059999942779541,8.875 C-5.059999942779541,8.875 2.052999973297119,-3.0510001182556152 2.052999973297119,-3.0510001182556152z M2.999000072479248,-14.897000312805176 C2.999000072479248,-14.897000312805176 -14.770999908447266,14.897000312805176 -14.770999908447266,14.897000312805176 C-14.770999908447266,14.897000312805176 14.770999908447266,14.897000312805176 14.770999908447266,14.897000312805176 C14.770999908447266,14.897000312805176 14.770000457763672,14.895999908447266 14.770000457763672,14.895999908447266 C14.770000457763672,14.895999908447266 2.999000072479248,-14.897000312805176 2.999000072479248,-14.897000312805176z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPimg);
export default __webpack_public_path__ + "static/media/pimg.00e3c911e17ed1ab1bbafd0b36101321.svg";
export { ForwardRef as ReactComponent };